import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveDistanceSort, deleteActivedistanceSort, setActiveDistanceSort, setActivedistanceSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopShoeDistance = ({ location, currentQuery, setCurrentQuery, distances, getSortParams, isHome, setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-distance button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.shoeDistance) {
        let shoeDistance = query.shoeDistance.split('_');
        shoeDistance.map(size => {
            var element = document.getElementById("shoeDistance_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome && currentQuery.genders == "Women" ? "Quel type de distance parcourt-elle ? (facultatif)" : 
                        isHome ? "Quel type de distance parcourt-il ? (facultatif)" : "Type de distances parcourues :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-distance mt-10" style={{display: 'block'}}>
                        {distances ? (
                            <ul>
                                {distances.map((distance, key) => {
                                    return (
                                        <li key={"shoeDistance_"+key}>
                                            <button
                                                className="toto"
                                                id={"shoeDistance_"+distance}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("distance", "");
                                                        setCurrentQuery({ ...currentQuery, shoeDistance: ""});
                                                        deleteActiveDistanceSort(e);
                                                    } else {
                                                        getSortParams("distance", distance);
                                                        setCurrentQuery({ ...currentQuery, shoeDistance: distance});
                                                        setActiveDistanceSort(e);
                                                    }
                                                }}
                                            >
                                                {t(distance.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome && currentQuery.genders == "Women" ? "Quel type de distance parcourt-elle ? (facultatif)" : 
                        isHome ? "Quel type de distance parcourt-il ? (facultatif)" : "Type de distances parcourues :"} &nbsp;</h4>
                        <div className="sidebar-widget-tag-distance mt-10">
                        {distances ? (
                            <ul>
                                {distances.map((distance, key) => {
                                    return (
                                        <li key={"shoeDistance_"+key}>
                                            <button
                                                className="toto"
                                                id={"shoeDistance_"+distance}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("distance", "");
                                                        setCurrentQuery({ ...currentQuery, shoeDistance: ""});
                                                        deleteActiveDistanceSort(e);
                                                    } else {
                                                        getSortParams("distance", distance);
                                                        setCurrentQuery({ ...currentQuery, shoeDistance: distance});
                                                        setActiveDistanceSort(e);
                                                    }
                                                }}
                                            >
                                                {t(distance.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(distance, t){
    switch (distance){
        case "Women":
            return t('distance')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveUsageQueryPath(query, sizeToRemove) {
    if (query && query.distances) {
        let distances = query.distances.split('_');
        distances = distances.filter(size => {
            return size !== sizeToRemove;
        })
        if (distances.length > 0) {
            let newSizeQuery = ""
            distances.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopShoeDistance.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopShoeDistance;
